import IconTime from '../icons/IconTime';
import IconPin from '../icons/IconPin';
import { useLang } from '../hooks/useLanguage';
import { TipTapRenderer } from './TipTapRenderer';
import IconEmail from '../icons/IconEmail';
import IconPhone from '../icons/IconPhone';

const Intro = function ({ show }) {
    const { getI18n, t } = useLang();
    const marketing = show?.marketing || {};

    return (
        <div className="fireknife-intro">
            <h2 className="fireknife-intro__title">{t('widgetInformations.description')}</h2>

            <div className="fireknife-intro__info">
                {marketing.duration && marketing.duration !== '' && (
                    <div className="fireknife-intro__info-item">
                        <IconTime className="fireknife-intro__info-item-icon" />
                        <div className="fireknife-intro__info-item-text">{`${marketing.duration} ${t('widgetInformations.hours')}`}</div>
                    </div>
                )}
                {marketing.location && marketing.location !== '' && (
                    <div className="fireknife-intro__info-item">
                        <IconPin className="fireknife-intro__info-item-icon" />
                        <div className="fireknife-intro__info-item-text">
                            {getI18n(marketing.location, marketing.locationI18n)}
                        </div>
                    </div>
                )}
            </div>
            <div className="fireknife-intro__info">
                {marketing.email && marketing.email !== '' && (
                    <div className="fireknife-intro__info-item">
                        <IconEmail className="fireknife-intro__info-item-icon" />
                        <div className="fireknife-intro__info-item">
                            {getI18n(marketing.email, marketing.emailI18n)}
                        </div>
                    </div>
                )}
                {marketing.phone && marketing.phone !== '' && (
                    <div className="fireknife-intro__info-item">
                        <IconPhone className="fireknife-intro__info-item-icon" />
                        <div className="fireknife-intro__info-item">
                            {getI18n(marketing.phone, marketing.phoneI18n)}
                        </div>
                    </div>
                )}
            </div>
            <div className="fireknife-intro__content">
                <TipTapRenderer content={getI18n(show.description, show.descriptionI18n)} />
            </div>
        </div>
    );
};

export default Intro;
